module.exports = "/assets/data/6a3e218dec56f67755419504618680ac-BN23.data.json";